import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../api";
import { CalendarCheck, Link2, Unlink } from "lucide-react";

// Admin panel: connect the Google account and map one calendar per photographer.
export const GoogleCalendarSettings = ({ team = [] }) => {
  const [st, setSt] = useState(null);
  const [map, setMap] = useState({});
  const [kreatif, setKreatif] = useState("");

  const load = async () => {
    const { data } = await api.get("/gcal/status");
    setSt(data); setMap(data.calendar_map || {}); setKreatif(data.kreatif_calendar_id || "");
  };
  useEffect(() => { load().catch(() => {}); }, []);

  const connect = async () => {
    try { const { data } = await api.get("/gcal/oauth/start"); window.location.href = data.url; }
    catch (e) { toast.error(e.response?.data?.detail || "Impossible de démarrer la connexion"); }
  };
  const save = async () => {
    await api.put("/gcal/mapping", { calendar_map: map, kreatif_calendar_id: kreatif });
    toast.success("Agendas enregistrés"); load();
  };
  const disconnect = async () => { await api.delete("/gcal/disconnect"); toast.success("Agenda déconnecté"); load(); };

  if (!st) return null;
  const cals = st.calendars || [];
  return (
    <div className="mt-10 pt-8 border-t border-[rgba(216,48,28,0.35)]" data-testid="gcal-settings">
      <h3 className="font-display text-xl mb-1 flex items-center gap-2"><CalendarCheck className="w-5 h-5 text-[#D8301C]"/>Agenda Google</h3>
      <p className="text-xs text-zinc-500 mb-4">
        {st.connected
          ? `Connecté avec ${st.account_email}. Les plages occupées dans l'agenda de chaque photographe bloquent les réservations.`
          : "Connectez le compte Google qui a le droit de modifier les agendas des photographes."}
      </p>
      {!st.configured && <p className="text-xs text-[#E6412D] mb-3">Identifiants Google Calendar manquants côté serveur.</p>}
      {!st.connected ? (
        <button onClick={connect} disabled={!st.configured} className="kr-btn kr-btn-primary text-sm flex items-center gap-2" data-testid="gcal-connect">
          <Link2 className="w-4 h-4"/>Connecter l'agenda
        </button>
      ) : (
        <>
          <div className="space-y-3">
            {team.filter(m => m.active !== false).map(m => (
              <div key={m.id} className="grid sm:grid-cols-2 gap-2 items-center">
                <label className="kr-caption">{m.display_name || m.name}</label>
                <select value={map[m.id] || ""} onChange={e => setMap({ ...map, [m.id]: e.target.value })}
                  data-testid={`gcal-cal-${m.id}`} className="bg-[#141414] border border-[rgba(216,48,28,0.35)] rounded-lg p-2 text-sm">
                  <option value="">— Aucun agenda —</option>
                  {cals.map(c => <option key={c.id} value={c.id}>{c.summary}</option>)}
                </select>
              </div>
            ))}
            <div className="grid sm:grid-cols-2 gap-2 items-center pt-2 border-t border-[rgba(216,48,28,0.35)]">
              <label className="kr-caption">Agenda de Kréatif (copie de chaque séance)</label>
              <select value={kreatif} onChange={e => setKreatif(e.target.value)} data-testid="gcal-cal-kreatif"
                className="bg-[#141414] border border-[rgba(216,48,28,0.35)] rounded-lg p-2 text-sm">
                <option value="">— Aucun agenda —</option>
                {cals.map(c => <option key={c.id} value={c.id}>{c.summary}</option>)}
              </select>
            </div>
          </div>
          <div className="flex gap-2 mt-4">
            <button onClick={save} className="kr-btn kr-btn-primary text-sm" data-testid="gcal-save">Enregistrer</button>
            <button onClick={disconnect} className="kr-btn kr-btn-ghost text-sm flex items-center gap-2" data-testid="gcal-disconnect"><Unlink className="w-4 h-4"/>Déconnecter</button>
          </div>
        </>
      )}
    </div>
  );
};
